module.exports = __webpack_public_path__ + "img/file.0a2e7f18.svg";